import { FC, useState } from 'react'

import LibrarySearch from 'components/search/library-search/library-search'
import SearchFilterContext from 'context/searchFilterContext'
import SwitchToggle from 'components/parts/switch-toggle/switch-toggle'
import BreadcrumbsPage from 'components/parts/breadcrumb-page/breadcrumb-page'
import useThemes from 'store/lists/useThemes'
import useLectures from 'store/lists/useLectures'
import useSpecialities from 'store/lists/useSpecialities'
import usePageFromSelectedOption from 'hooks/usePageFromSelectedOption'
import SEOContext from 'context/SEOContext'

import { FilterIndex } from 'constants/search-data/search-data'
import { INewslineCard } from 'constants/types/card.types'
import { Pathname } from 'constants/data'
import { options, OptionAliases, optionsLinks } from 'constants/search-data/library-search-data'
import { IOptions } from 'constants/types/common.types'
import { LibraryArticleSEO } from 'constants/SEO'
import { URL_SITE } from 'constants/data'

import styles from './library-layout.module.scss'

interface ILibrarySearchLayout {
  title?: string
  targetInitParams?: IOptions
  initCards?: {
    count: number
    rows: INewslineCard[]
  }
}

const LibrarySearchLayout: FC<ILibrarySearchLayout> = ({
  title = 'Библиотека',
  targetInitParams,
  initCards,
  children,
}) => {
  const [filterState, setFilterState] = useState(FilterIndex.TURN_OFF_INDEX)
  const themes = useThemes()
  const lectures = useLectures()
  const specialities = useSpecialities()
  const { selectedOption, setSelectedOption } = usePageFromSelectedOption(
    OptionAliases,
    `/${Pathname.LIBRARY}`
  )
  const isTarget = Boolean(targetInitParams)
  const setFilter = (filter?: number) => {
    if (!filterState) return setFilterState(FilterIndex.TURN_ON_INDEX)
    if (typeof filter === 'number') return setFilterState(Number(filter))
    if (filterState > FilterIndex.TURN_ON_INDEX) return setFilterState(FilterIndex.TURN_ON_INDEX)
    return setFilterState(FilterIndex.TURN_OFF_INDEX)
  }

  const providerValues = { filterState, setFilter }

  return (
    <>
      {children}
      <SearchFilterContext.Provider value={providerValues}>
        <SEOContext.Provider value={LibraryArticleSEO}>
          <LibrarySearch
            lectures={lectures}
            themes={themes}
            specialities={specialities}
            selectedOption={selectedOption}
            targetInitParams={targetInitParams}
            initCards={initCards}
          >
            <div>
              <div className={styles.breadcrumb}>
                <BreadcrumbsPage
                  breadData={[{ name: 'Библиотека', link: `${URL_SITE}/library` }]}
                />
              </div>

              <h1 className={styles.titleFirst} dangerouslySetInnerHTML={{ __html: title }} />
              {!isTarget && (
                <div className={styles.switchToggleWrapper}>
                  <SwitchToggle
                    options={options}
                    selectedOption={selectedOption}
                    handleToggle={setSelectedOption}
                    optionsLinks={optionsLinks}
                  />
                </div>
              )}
            </div>
          </LibrarySearch>
        </SEOContext.Provider>
      </SearchFilterContext.Provider>
    </>
  )
}

export default LibrarySearchLayout
